import { Card, Flex, Image } from "antd"
import styled from "styled-components"
import { OrderInfoInterface } from "../../types"

const TextBox = styled.div`
    margin-bottom: 5px;
    font-size: 1rem;
`

interface ProductProps {
    id: number
    title: string
    image: string
    text: string
    defaultConcentration: number
    price: number
    orderInfo: OrderInfoInterface
    highlight?: boolean

    setOrderInfo: React.Dispatch<React.SetStateAction<OrderInfoInterface>>
    setCurrentStep: React.Dispatch<React.SetStateAction<number>>
}

export const Product = (props: ProductProps): JSX.Element => {
    return (
        <Card
            onClick={() => {
                props.setOrderInfo({
                    ...props.orderInfo,
                    productid: props.orderInfo.productid === props.id ? null : props.id,
                    ordername: "",
                    samples: [],
                    sample_names:'',
                    sample_sequences:'',
                    sequenceupload: undefined,
                    
                })
            }}
            style={{
                width: 240,
                height: 260,
                borderStyle: "solid",
                borderColor: props.highlight ? "#9d5303" : "#039d60",
                boxShadow: props.highlight ? "1px 1px 7px 7px #106e49" : "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                cursor: "pointer",
            }}
            styles={{
                header: {
                    borderBottom: "none",
                    background: "#039d60",
                    fontSize: "1rem",
                    padding: "5px 5px 5px 5px",
                    height: "10px",
                    minHeight: "35px",
                },
                title: { color: "white", display: "flex", justifyContent: "center" },
                body: { color: "black", padding: "5px 5px 5px 5px" },
                cover: { borderBottom: "1px solid #c8cdcb", marginBottom: "5px" },
            }}
            cover={
                <div
                    style={{
                        margin: "auto",
                        width: "160px",
                        height: "160px",
                        marginTop: "1em",
                        borderStyle: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Image alt="plasmid map" preview={false} src={props.image} width={130} height={130} />
                </div>
            }
            title={<div style={{ borderStyle: "none" }}>{props.title}</div>}
        >
            <Flex vertical align="center" justify="center">
                <TextBox>{`$${props.price} per sample`}</TextBox>
            </Flex>
        </Card>
    )
}
